/**
* @author: yami
* @description：格式化银行卡号
*/

export default function formatBackCardNo (val) {
  if (!val) return val
  val = `${val}`
  return val.replace(/([\s\S]{4})(?=[\s\S])/g, '$1 ')
}
